import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";

import Layout from "layout";
import Card from "components/card";
import { t } from "intl/index";
import useAppStore from "stores/appStore";

const Wrapper = styled.div`
  text-align: center;
`;

const ThankYouForAnswering = ({ thankYouPageString }) => {
  const { lang } = useAppStore();
  const LANG_MAP = t(lang);
  const hasCustomThankYou = Boolean(thankYouPageString && String(thankYouPageString).trim());

  return (
    <Layout withoutHeader={true}>
      <Card>
        <Wrapper>
          {hasCustomThankYou ? ReactHtmlParser(thankYouPageString) : <h3>{LANG_MAP.THANK_YOU}</h3>}
        </Wrapper>
      </Card>
    </Layout>
  );
};

ThankYouForAnswering.propTypes = {
  thankYouPageString: PropTypes.string,
};

ThankYouForAnswering.defaultProps = {
  thankYouPageString: "",
};

export default ThankYouForAnswering;
